import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'mainPage.title.welcome',
        defaultMessage: 'Welcome'
    },
    MAIN_MESSAGES: {
        id: 'mainPage.header.mainMessages',
        defaultMessage: 'Main messages'
    },
    MESSAGES_EMPTY: {
        id: 'mainPage.messages.empty',
        defaultMessage: 'No message set'
    },
});

export default messages;
